const getPlanDuration = (productId: number) => {
    switch (productId) {
      case 1:
        return 1;
      case 2:
        return 6;
      case 3:
        return 12;
      default:
        return 0;
    }
  }

  export default getPlanDuration